/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BeakerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABVUlEQVR4nO1UOU5DQQwdKFgqlho6Kgo4Am2k4CWAsQNFKOhpoYo4BHCFgLhDJBA1YrkAi6hYCwoqkPM/zeRDws9vQFiaZux5z89jvRD+dADbCbK9f3tIj3MT+ONOBMB21JMKTIG6ve+ZAKKxFU6A0dgKJ/iM/xG1QkQGWqtI9hai8DvPeU3IG8C6kOy6nsY5ZD3z3DxVF3OBI8o0sj4mCnQtzhNV15OP1pdyZXn2R+CVyuoEsF0nVmAHIYS+uKZer/cj62HawA2RTnYFLiIjwHqePrxHtCURGc+qnavVhtwq0kYuiGqj34KXSqVBYGtmeM4rsm5kvSmXV8aQ9TL1paZjZIK7ZGBrdHDOfQCb8ZEByBSQbSPbVWR+DcdqIwC2rY7WzN0e3WwnIL0rjsBuMxToU1EEQPaQpWCvMAVku20EIjLsJED2nLtz9inojq/v17v62+IDsdeX7fSuInEAAAAASUVORK5CYII=)
 */
export const BeakerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M16 10.49V4a1 1 0 1 0 0-2H8a1 1 0 0 0 0 2v6.49a2 2 0 0 1-.5 1.33l-4.77 5.36A2.9 2.9 0 0 0 4.9 22h14.2a2.9 2.9 0 0 0 2.17-4.82l-4.76-5.36a2 2 0 0 1-.51-1.33ZM10 4v6.49a4 4 0 0 1-1.01 2.66l-1.35 1.51c1.14-.1 2.3.28 3.17 1.15l.13.13a3.73 3.73 0 0 0 4.56.56 3.73 3.73 0 0 1 2.02-.53L15 13.15A4 4 0 0 1 14 10.49V10h-1a1 1 0 1 1 0-2h1V7h-1a1 1 0 1 1 0-2h1V4h-4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
